import { Answer } from './Answer.model';

export class Question {
  Question: string = "";
  Answers: Answer[]=[];
  
}
